<template>
  <div id="app">
    <RiClothesHeader></RiClothesHeader>
    <transition mode=out-in>
      <router-view class="router-container" />
    </transition>
    <RiClothesFooter></RiClothesFooter>
  </div>
</template>

<script>
import RiClothesHeader from "@/components/RiClothesHeader.vue";
import RiClothesFooter from "@/components/RiClothesFooter.vue";

export default {
  name: "App",
  components: {
    RiClothesHeader,
    RiClothesFooter
  }
}
</script>

<style>
body {
  padding: 0px;
  margin: 0px;
  background-color: var(--surface-color);
}

.body-transition {
  transition: 0.5s;
}

.v-enter {
  transform: translateY(25px);
  opacity: 0;
}
.v-enter-to {
  opacity: 1;
}
.v-enter-active {
  transition: all 0.5s ease;
}
.v-leave {
  opacity: 1;
}
.v-leave-to {
  opacity: 0;
}
.v-leave-active {
  transition: all 0.25s ease;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  width: 100%;
}

.router-container {
  margin-top: 72px;
  min-height: 85vh;
}

@media screen and (max-width: 896px) {
  .router-container {
    margin-top: 64px;
  }

}
</style>
